'use client';

import { useEffect } from 'react';
import { setupChunkErrorHandler } from '@/lib/utils/chunk-error-handler';

type WebpackRequire = ((...args: unknown[]) => unknown) &
  Record<string, unknown>;

function instrumentWebpackRequire() {
  const win = window as Window & { __webpack_require__?: WebpackRequire };
  const originalImport = win.__webpack_require__;
  if (!originalImport || typeof originalImport !== 'function') {
    return;
  }
  const wrappedImport = function (this: unknown, ...args: unknown[]) {
    try {
      return (originalImport as WebpackRequire).apply(this, args);
    } catch (error) {
      console.warn('Webpack require error (chunk loading):', error);
      throw error;
    }
  } as WebpackRequire;
  Object.setPrototypeOf(wrappedImport, originalImport);
  Object.getOwnPropertyNames(originalImport).forEach((key) => {
    if (key !== 'length' && key !== 'name' && key !== 'prototype') {
      wrappedImport[key] = (originalImport as WebpackRequire)[key];
    }
  });
  win.__webpack_require__ = wrappedImport;
}

/**
 * Global chunk error handler component
 * Sets up window event listeners to handle chunk loading errors
 */
export function ChunkErrorHandler() {
  useEffect(() => {
    const cleanup = setupChunkErrorHandler();
    instrumentWebpackRequire();
    return cleanup;
  }, []);

  // This component doesn't render anything visible
  return null;
}

// Type declaration for webpack require
declare global {
  interface Window {
    __webpack_require__?: ((...args: unknown[]) => unknown) &
      Record<string, unknown>;
  }
}
